<template>
    <div>
        <b-tabs>
            <b-tab title="Dados Gerais">
                <div>
                    <b-card>

                        <b-form-row>

                            <lg-form-input disabled v-model="form.itemRegEntrada.produto.descricaoResumida"
                                label="Descrição:" cols="8" />

                            <lg-form-input disabled v-model="form.situacao" label="Status:" cols="4" />


                        </b-form-row>
                        <b-form-row>

                            <lg-form-input disabled v-model="form.numTombamento" label="Nº Tombamento:" cols="3" />

                            <b-col cols="2">
                                <b-button id="localizarHistTomb" class="ml-3 my-2 mt-3" size="sm" style="height: 40px"
                                    pill variant="primary" @click="abrirModalHistorico">
                                    <div class="btn-size-alinhamento">

                                        <b-icon icon="clock" />
                                    </div>
                                    <b-tooltip target="localizarHistTomb" title="Histórico de Tombamento"></b-tooltip>
                                </b-button>
                            </b-col>

                            <div class="col-3"></div>
                            <lg-form-input disabled v-model="form.s_numTombAntigo" label="Nº Tombamento Samp:"
                                cols="3" />

                            <div class="col-2">
                            </div>

                        </b-form-row>

                        <b-form-row>


                            <lg-form-date description=" " v-model="form.dataTombamento" label="Data Tombamento:"
                                cols="8" disabled />

                            <lg-form-date description=" " v-model="form.dataTombamentoAntiga"
                                label="Data Tombamento Samp:" cols="4" disabled />

                        </b-form-row>
                        <b-form-row>
                            <b-form-group label="Bem Relacionável:" class="mb-0 col-8" v-slot="{ ariaDescribedby }">

                                <b-form-radio-group disabled v-model="form.relacionado" :options="[
                                    { text: 'Sim', value: 1 },
                                    { text: 'Não', value: 0 }
                                ]" :aria-describedby="ariaDescribedby"></b-form-radio-group>
                            </b-form-group>

                            <lg-form-date class="" description=" " v-model="form.dhCriacao" label="Data Aquisição:"
                                cols="4" disabled />


                        </b-form-row>
                        <b-form-row>
                            <LgFinderPageEspecificacaoProdutoAlmoxarifado label='Especificação:' :prefix='updatedPrefix'
                                class='col-8 p-0' id='finderEspecificacao' v-model="form.especificacaoProduto">
                            </LgFinderPageEspecificacaoProdutoAlmoxarifado>

                            <lg-form-input disabled v-model="form.valorOriginal" label="Valor Aquisição:" cols='4' />
                        </b-form-row>


                        <b-form-row>
                            <b-col cols="8">
                                <b-form-group label="Descrição Detalhada:">
                                    <textarea v-model="form.itemRegEntrada.produto.descricaoDetalhada" rows="5"
                                        class="form-control"></textarea>
                                </b-form-group>
                            </b-col>
                            <b-col cols="4" style="margin-left: -14px;">
                                <lg-form-input disabled v-model="form.valor" label="Valor Atual:" cols="12" />
                                <lg-form-date label="Garantia:" description="" v-model="form.dataGarantia" cols="12" />
                                <lg-form-input label="Status:" disabled v-model="form.status.descricao" cols="12" />
                            </b-col>
                        </b-form-row>


                        <b-form-row>
                            <b-col cols='8'>
                                <lg-form-input description=" " class='p-0' v-model="form.numSerie" label="Nº Série:" />
                            </b-col>
                            <b-col cols='4'>
                                <LgFinderPageMarca label='Marca:' id='finderPageMarcaEdit' v-model='form.marca'
                                    :prefix="updatedPrefix">
                                </LgFinderPageMarca>
                            </b-col>

                            <b-col cols="8">
                                <LgFinderPageLote :produto='form.itemRegEntrada.produto' id='finderPageLoteEdit'
                                    :almoxarifado='form.almoxarifadoDto' label='Nº Lote:' :disabled='true'
                                    :title='title' v-model="form.lote">
                                </LgFinderPageLote>
                            </b-col>
                            <b-col cols="4">
                                <LgFinderPageModelo label='Modelo:' id="finderPageModeloEdit" :prefix="updatedPrefix"
                                    v-model='form.modelo'>
                                </LgFinderPageModelo>

                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <lg-form-input description=" " disabled v-model="form.lotacao.departamento.descricao"
                                label="Unidade Administrativa:" cols="12" />

                            <lg-form-input description=" " disabled v-model="form.lotacao.departamento.sigla"
                                label="Sigla:" cols="12" />
                            <b-col cols='8'>
                                <LgFinderPageLocalArmazenamento label="Localizacao:" v-model="form.localArmazenamento"
                                    id='finderPageLocalArmazenamento' />
                            </b-col>

                            <lg-form-input description=" " disabled
                                v-model="form.localArmazenamento.tipoLocalArmazenamento.descricao"
                                label="Tipo Localização:" cols="4" />


                            <lg-form-input description=" " v-model="form.complemento" label="Complemento:" cols="12" />


                            <lg-form-input description=" " disabled v-model="form.lotacao.pessoa.nome"
                                label="Responsável UA:" cols="12" />
                            <b-col cols='12'>
                                <LgFinderPagePessoa label="Utilizado por:" v-model="form.pessoa" id='finderPessoa'
                                    :prefix="title + ' > '">
                                </LgFinderPagePessoa>

                            </b-col>

                            <b-col cols='12'>
                                <LgFinderPagePessoa label="Responsável:" v-model="form.pessoaResponsavel"
                                    id='finderPessoaResp' :prefix="title + ' > '">
                                </LgFinderPagePessoa>

                            </b-col>

                            <b-col cols='12'>
                                <LgFinderPagePessoa label="Co Responsável:" v-model="form.pessoaCoResponsavel"
                                    id='finderPessoaCoResp' :prefix="title + ' > '">
                                </LgFinderPagePessoa>

                            </b-col>



                        </b-form-row>

                    </b-card>
                </div>
            </b-tab>
            <b-tab title="Registro Entrada">
                <RegistroEntradaView :id="this.form.id" v-if="this.form.id"></RegistroEntradaView>
            </b-tab>

        </b-tabs>
        <ModalHistoricoTombamentoList v-if="mostrarModal" :item="this.itemHistorico" :prefix="prefix"
            @fecharModal="fecharModal"></ModalHistoricoTombamentoList>
    </div>
</template>
<script>


import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ModalHistoricoTombamentoList from "@/core/components/Modals/ModalHistoricoTombamentoList.vue"
import { FormResourceMixin } from "@/core/mixins/resource"
import RegistroEntradaView from "@/modules/almoxarifados/registros-entrada/RegistroEntradaView.vue"
import LgFinderPageEspecificacaoProdutoAlmoxarifado from "../../../components/Finders/LgFinderPageEspecificacaoProdutoAlmoxarifado.vue"
import LgFinderPageLocalArmazenamento from "../../../components/Finders/LgFinderPageLocalArmazenamento.vue"
import LgFinderPageLote from "../../../components/Finders/LgFinderPageLote.vue"
import LgFinderPageMarca from "../../../components/Finders/LgFinderPageMarca.vue"
import LgFinderPageModelo from "../../../components/Finders/LgFinderPageModelo.vue"
import API from "../../../core/api"

export default {
    components: {
        LgFormInput,
        LgFormDate,
        RegistroEntradaView,
        ModalHistoricoTombamentoList,
        LgFinderPageEspecificacaoProdutoAlmoxarifado,
        LgFinderPageMarca,
        LgFinderPageModelo,
        LgFinderPageLote,
        LgFinderPagePessoa,
        LgFinderPageLocalArmazenamento
    },
    props: {
        id: Number,
        prefix: { type: [String, Array], default: "" }
    },

    mixins: [FormResourceMixin],


    computed: {
        updatedPrefix() {
            return [...this.prefix, "Cadastro"].filter(item => item && item != "")
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },

    data() {
        return {
            itemHistorico: null,
            mostrarModal: false,
            showModal: true,
            form: {
                pessoa: { nome: "" },
                localArmazenamento: { descricao: "", tipoLocalArmazenamento: { descricao: '' } },
                lote: { descricao: "" },
                lotacao: { pessoa: { nome: "" }, departamento: { descricao: '', sigla: '' } },
                itemRegEntrada: { descricao: '', produto: { descricao: '' } },
                tipoAquisicao: { descricao: '' },
                notaFiscal: "",
                vlNotaFiscal: 0,
                nroEmpenho: "",
                empenho: {},
                descricao: "",
                numeroTombamento: "",
                numeroTombamentoSamp: "",
                dataTombamento: "",
                dataTombamentoSamp: "",
                dataAquisicao: "",
                especificacaoProduto: { descricao: "" },
                valorAquisicao: "",
                descricaoDetalhadaProduto: "",
                valorAtual: "",
                numeroSerie: "",
                status: { descricao: "" },
                numeroLote: "",
                dataGarantia: "",
                marca: { descricao: "" },
                modelo: { descricao: "" },
                unidadeAdministrativa: "",
                sigla: "",
                localizacao: "",
                complemento: "",
                responsavelUnidadeAdministrativa: "",
                utilizadoPor: "",
                data: new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
            },
            itensFields: [
                { key: "numTombamento", label: " Tombamento" },
                { key: "s_numTombAntigo", label: "Tombamento Samp" },
                { key: "itemRegEntrada.produto.numero", label: "Numero" },
                { key: "itemRegEntrada.produto.descricaoResumida", label: "Descrição" },
                { key: "relacionado", label: "Br" },
                { key: "valorOriginal", label: "Valor Aquisição" },
            ],
        }
    },
    async beforeMount() {
        this.busy = true
        this.$service = new ResourceService(`/api/consultaitembempermanente`)
        this.$service.findById(this.id).then(response => {
            var data = response.data

            data.status = data.status ? data.status : { descricao: '' }
            data.situacao = data.situacao == 1 ? 'ATIVO' : 'INATIVO'
            data.lote = data.lote ? data.lote : { descricao: '' }
            data.especificacaoProduto = data.especificacaoProduto ? data.especificacaoProduto : { descricao: "" }
            data.lotacao.pessoa = data.lotacao.pessoa ? data.lotacao.pessoa : { nome: "" }
            data.pessoa = data.pessoa ? data.pessoa : { nome: "" }
            data.marca = data.marca ? data.marca : { descricao: "" }
            data.modelo = data.modelo ? data.modelo : { descricao: "" }
            data.dhCriacao = data.dhCriacao.split('T')[0]
            data.dataEntrada = data.dataEntrada.split('T')[0]
            data.dataTombamento = data.dataTombamento.split('T')[0]
            if (data.localArmazenamento)
                data.localArmazenamento.tipoLocalArmazenamento = data.localArmazenamento.tipoLocalArmazenamento ? data.localArmazenamento.tipoLocalArmazenamento : { descricao: "" }
            else
                data.localArmazenamento = { tipoLocalArmazenamento: { id: null, descricao: "" } }

            this.form = data

            this.busy = false

        })

    },


    methods: {
        cancelar() {
            this.$emit("fecharModal")
        },
        fecharModal() {
            this.itemHistorico = null
            this.mostrarModal = false
        },
        abrirModalHistorico() {

            this.itemHistorico = this.form
            this.mostrarModal = true
        },
        async submitForm() {
            this.busy = true
            try {
                await API.put(`/api/consultaitembempermanente/${this.id}`, this.form, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                this.$emit('fecharModal')
            } catch (error) {
                console.error("Erro ao atualizar o item:", error)
            } finally {
                this.busy = false
            }
        }
    },
}
</script>